import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../hooks/StoreHooks";
import { fetchGroupsThunk } from "../../store/thunk/groupsThunk";
import { fetchActionModules } from "../../store/thunk/actionsModulesThunk";
import ActionsBlock from "./ActionsBlock/ActionsBlock";
import PageTitle from "../../components/common/PageTitle/PageTitle";

const breadcrumbs = [];

const ActionModules = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(fetchGroupsThunk());
    dispatch(fetchActionModules());
  }, []);

  return (
    <>
      <PageTitle
        breadcrumbs={breadcrumbs}
        title={t("actionModulesPage.actionModules.title")}
      />
      <ActionsBlock />
    </>
  );
};

export default ActionModules;
